import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { filter, some } from 'lodash';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { CompaniesService } from '../companies/companies.service';
import { CompaniesHistoricalWellsFormComponent } from '../companies/historical-wells/historical-wells-form.component';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { HistoricalWellsService } from './historical-wells.service';
import { Subscription } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';

@Component({
  selector: 'app-historical-wells',
  templateUrl: './historical-wells.component.html',
  styleUrls: ['./historical-wells.component.scss']
})
export class HistoricalWellsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  companyId: number;
  loading: boolean = false;
  data: any[] = [];
  pageInfo: any = {
    totalCount: null,
    maxItem: null,
  };
  checkAll: boolean = false;
  hideButton: boolean = false;
  // isOperatorCompany: boolean = false;
  listSelectWells = [];
  tableSettings: any = {
    noDataMessage: null,
    actions: {
      add: false,
      edit: false,
      delete: false,
      columnTitle: 'Action'
    },
    hideSubHeader: true,
    pager: {
      perPage: 24,
    },
    columns: {
      wellName: {
        title: 'Well Name',
        type: 'string',
        width: '20%',
        sort: false,
      },
      wellAPI: {
        title: 'Well API/UWI',
        type: 'number',
        width: '15%',
        sort: false,
      },
      serviceCompanyName: {
        title: 'Service Company',
        type: 'string',
        width: '15%',
        sort: false,
      },
      operatorCompanyName: {
        title: 'Operator',
        type: 'string',
        width: '15%',
        sort: false,
      },
      country: {
        title: 'Country',
        type: 'string',
        width: '15%',
        sort: false,
      },
      state: {
        title: 'State',
        type: 'string',
        width: '10%',
        sort: false,
      },
      county: {
        title: 'County',
        type: 'string',
        width: '10%',
        sort: false,
      },
    },
  };

  @Output() dataWells: EventEmitter<any> = new EventEmitter();
  @Output() checkAllWell: EventEmitter<any> = new EventEmitter();

  dataSource: any = new LocalDataSource();

  constructor(private companiesService: CompaniesService,
              private dialogService: NbDialogService,
              private userAuthService: UserAuthService,
              private historicalWellsService: HistoricalWellsService) {
    const user = this.userAuthService.getUserInfo();
    this.companyId = user.companyId;
  }

  ngOnInit() {
    this.getCompanyInfo();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  onDeleteConfirm(item): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {config: {
        title: 'Delete',
        message: `Are you sure you want to delete <br> <b class="h6">${item.data.wellName}</b>?`,
        className: 'pop-delete common-page',
        btnTxtConfirm: 'Yes',
        btnTxtCancel: 'No',
        data: item.data,
      }}
    }).onClose.subscribe(res => {
      if (res.confirm) {
        this.subscriptions.push(
          this.historicalWellsService.delete(res.data.id).subscribe(
            () => {
              this.loadData();
            }
          ));
      }
    });
  }

  getData() {
    const data = this.dataSource.getAll();
    this.data = data['__zone_symbol__value'];
    this.listSelectWells = filter(this.listSelectWells, (item: any) => {
      return !some(this.data, ['id', item.id]);
    });
    this.hideButton = this.pageInfo.maxItem <= this.pageInfo.totalCount;
    return this.data;
  }

  getSelectedWells() {
    let selectedWells = this.listSelectWells;
    if (this.data && this.data.length > 0) {
      selectedWells = selectedWells.filter(item => (this.data.indexOf(item) === -1));
    }
    return selectedWells.map(item => {
      delete item.selected;
      return item;
    });
  }

  onAddNew() {
    this.dialogService.open(CompaniesHistoricalWellsFormComponent, {
      context: {
        listWells: this.getSelectedWells(),
        maxWells: this.pageInfo.maxItem,
        countItemWells: this.pageInfo.totalCount,
      },
      autoFocus: false,
    }).onClose.subscribe(res => {
      if (res) {
        const param = {
          ids: res.map(item => (item.id)),
        };
        this.subscriptions.push(
          this.historicalWellsService.updateByCompany(param).subscribe(
            () => {
              this.loadData();
            }
          ));
      }
    });
  }
  onCancel() {
  }

  getWellWithCompanyId() {
    this.subscriptions.push(this.companiesService.getWellByCompanyId().subscribe(
      (res) => {
        this.listSelectWells = res.result.items;
        this.getData();
      }));
  }

  loadData() {
    this.loading = true;
    this.subscriptions.push(this.historicalWellsService.getAll().subscribe(
      (res) => {
        if (res) {
          this.dataSource.load(res.result.items);
          this.pageInfo.totalCount = res.result.totalCount;
          this.getWellWithCompanyId();
        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      }
    ));
  }

  getCompanyInfo() {
    this.loading = true;
    this.subscriptions.push(
      this.companiesService.getCompanyId(this.companyId).subscribe(
        (res) => {
          this.pageInfo.maxItem = res.result.maxHistoricalWell;
          this.checkAll = res.result.isAllWell;
          this.loadData();
        }, (error) => {
          this.loading = false;
        }
      ));
  }

}
